import React , {useState, useEffect }from "react";

import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Avatar from "@mui/material/Avatar";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import DonationList from "../DashBoardView/DonationList";

import { useDispatch, useSelector } from "react-redux";
import {
  getDonationBySearchKey,
  getMyActiveDonation,
  setMyActiveDonationsLimit,
  setMyActiveDonationsOffset,
  setMyActiveDonationsPage,
  setSelectedDonation,
} from "../DashBoardView/slice";
import { db, storage } from "../../firebase.js";
import {
query,
where,
getCountFromServer,
collection as firebaseCollection,
getDocs,
documentId,
onSnapshot,
collectionGroup,
} from "firebase/firestore";
import Pagination from "@mui/material/Pagination";
import { DonationStatus, EntityType } from "../../common/enum";
import SvgIconStyle from "../../components/SvgIconStyle";
import DonationCard from "./DonationCard/index.js";
import DonationHeader from "./DonationHeader";
import Loader from "../../components/Loader";
import Filter from "../DashBoardView/CollectorDonationView/Filter";
import { Grid } from "@mui/material";
import OrderDonation from "../DashBoardView/CollectorDonationView/OrderDonation";
var mensagensEntidades = [];
var uniqueArray =[];
const mainBoxStyles = { display: "flex", justifyContent: "space-between" };

const avataStyles = { bgcolor: "#E4F2E8", width: "58px", height: "58px" };

const svgIconStyle = { color: "black", width: "40px", height: "40px" };

const donorFilterObj = {
  donor: false,
  event: false,
};

const orderByObj = {
  nearestExpiry: false,
};

const Donations = ({ donationStatus, t }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const [donorFilter, setDonorFilter] = React.useState(donorFilterObj);
  const [orderCheck, setOrderCheck] = React.useState(orderByObj);
  const [idValue, setIdValue] = React.useState("");
  const [messageUserCount, setMessageUserCount] = React.useState(0);
  const [value, setValue] = React.useState(0);
  const [entities, setEntities] = React.useState([]);
  const [mensagens, setMensagens] = React.useState([]);

  const [mensagensEntidades2, setMensagensEntidades] = useState([]);
  const {
    auth: { profile },
  } = useSelector((state) => state);

  const {
    dashboardInfo: {
      loading,
      myActiveDonations,
      myActiveDonationsTotalCount,
      myActiveDonationsPage,
      entityProfileSelect,
    },
    auth: {
      user: {userId},
      profile: { entity },
    },
  } = useSelector((state) => state);

  const setDonorFilterValue = React.useCallback((value) => {
    setDonorFilter(value);
  }, []);

  const setOrderCheckValue = React.useCallback((value) => {
    setOrderCheck(value);
  }, []);

  const getDonations = React.useCallback(
    (payload, limit, offset, page) => {
      dispatch(getMyActiveDonation(payload));
      dispatch(setMyActiveDonationsLimit(limit));
      dispatch(setMyActiveDonationsOffset(offset));
      dispatch(setMyActiveDonationsPage(page));
    },
    [dispatch]
  );

  const totalPageCount = React.useMemo(() => {
    return Math.ceil(myActiveDonationsTotalCount / 10);
  }, [myActiveDonationsTotalCount]);
  
  // React.useEffect(() => {
  //   const queryPromises = [];

  //   for (let index = 0; index < myActiveDonations.length; index++) {
  //     const donationId = myActiveDonations[index].donation?.donationId;
  
  //     if (donationId) {
  //       const q = query(
  //         firebaseCollection(db, "entityChats", profile?.userId, "entityInfo"),
  //         where("donationId", "==", donationId)
  //       );
  
  //       const queryPromise = new Promise((resolve, reject) => {
  //         const unsub = onSnapshot(q, (snap) => {
  //           const arr = [];
  //           snap.forEach((doc) => {
  //             arr.push(doc.data());
  //           });
  //           setEntities([...arr]);
  //           console.log([...arr], 'setEntities([...arr]);');
  //           mensagensEntidades.push({ "Mensagens": arr.length, "indexDonation": index, "donationId": donationId });
  //           // Resolve the Promise when the query is done
  //           resolve();
  //         });
  //       });
  
       
  //     }
  //   }
  // })
  useEffect(() => {
    const queryPromises = [];
    const unsubscribes = [];

        // const q = query(
        //   firebaseCollection(db, "entityChats", profile?.userId, "entityInfo" ),
         
        // );
        const q = query(
          firebaseCollection(
            db,
            "entityChats",
            profile?.entity.entityId,
            "entityInfo"
          ),
        
        );
        uniqueArray=[];
        const queryPromise = new Promise((resolve) => {
          const unsub = onSnapshot(q, (querySnapshot) => {
            const arr = [];
            querySnapshot.forEach((doc) => {
                arr.push(doc.data());
              });
            arr.forEach((cc)=>{
              const qu = query(
                firebaseCollection(
                  db,
                  "entityDonationsChat",
                  cc.entityDonationChatUid,
                  "donationInfo"
                ),  
              );
              const unsub2 = onSnapshot(qu, (querySnapshot2) => {
                const arr2 = []; 
                querySnapshot2.forEach((doc2) => {
                  arr2.push(doc2.data());
                  setEntities([...arr2]);
                  var arrayfiltrado = arr2.filter(message => message.donationId)
                  arrayfiltrado.forEach((ff)=>{
                    uniqueArray.push(ff)
                     mensagensEntidades = uniqueArray.filter((item, index, array) => {
                      return array.findIndex(obj => obj.donationId === item.donationId) === index;
                    });
                    
                  })
                  //console.log(mensagensEntidades, 'setEntities([...arr]);');
                  
                
                  resolve();
                });
              });
              
            })
             
          });

          unsubscribes.push(unsub);
        });

        queryPromises.push(queryPromise);
       
      //}
    

    return () => {
      // Unsubscribe from all snapshot listeners to clean up when the component unmounts.
      unsubscribes.forEach((unsubscribe) => {
        unsubscribe();
      });
    };
  }, [myActiveDonations, profile]);
  React.useEffect(() => {
    let limit = 10;
    let offset = 0;
    let page = 1;
    let data = {
      offset: offset,
      limit: limit,
      isNearestExpiry: orderCheck.nearestExpiry,
      entityType : entity?.entityType === EntityType.donorDistributor ? entityProfileSelect : entity?.entityType,
      status : donationStatus
    };
    data["entityId"] = userId;
    if (donorFilter.donor || donorFilter.event) {
      let isEvent = donorFilter.event ? true : false;
      data["isEvent"] = donorFilter.donor && donorFilter.event ? null : isEvent;
      getDonations(data, limit, offset, page);
    } else {
      getDonations(data, limit, offset, page);
    }
  }, [donorFilter, orderCheck]);

  const handleChange = (event, value) => {
    let limit = 10;
    let offset = 0;
    if (value > 1) {
      limit = value * 10;
      offset = limit - 10;
    }
    const data = {
      offset: offset,
      limit: limit,
      isNearestExpiry: orderCheck.nearestExpiry,
      entityType : entity?.entityType === EntityType.donorDistributor ? entityProfileSelect : entity?.entityType,
      status : donationStatus
    };
    data["entityId"] = userId;
    if (
      entity.entityType === EntityType.donor ||
      entityProfileSelect === EntityType.donor
    ) {
      if (donorFilter.donor || donorFilter.event) {
        let isEvent = donorFilter.event ? true : false;
        data["isEvent"] =
          donorFilter.donor && donorFilter.event ? null : isEvent;
      }
    }
    getDonations(data, limit, offset, value);
  };

  const changeIdValue =(e)=>{
    const value =e && e.target && e.target.value
    setIdValue(e.target.value);
    if(value && value.length>4 || value && value.length==0){
      const removeYear = value.slice(4);
      dispatch(getDonationBySearchKey(removeYear))
    }
    else if(value==="") {
      let limit = 10;
      let offset = 0;
      let page = 1;
      let data = {
        offset: offset,
        limit: limit,
        isNearestExpiry: orderCheck.nearestExpiry,
        entityType : entity?.entityType === EntityType.donorDistributor ? entityProfileSelect : entity?.entityType,
        status : donationStatus
      };
      data["entityId"] = userId;
      if (donorFilter.donor || donorFilter.event) {
        let isEvent = donorFilter.event ? true : false;
        data["isEvent"] = donorFilter.donor && donorFilter.event ? null : isEvent;
        getDonations(data, limit, offset, page);
      } else {
        getDonations(data, limit, offset, page);
      }
    }
  }
  donationcardgrid();

  async function donationcardgrid() {
   
    // Use a Promise to wait for all queries to complete
    
  }

  return (
    <Stack
      spacing={1}
      sx={{
        padding: '8px 0',
        width: 1,
      }}
    >
      {matches && <DonationHeader t={t} />}
        {/* <Grid container spacing={1}>
          <Grid item xs={10}
            sx={{
              display: "flex",
              '@media (max-width:700px)': {
                flexDirection: "column"
              }
          }}>
            <Grid item xs={12} lg={2.5}>
            <input type="text" placeholder={t('searchID')} 
            onChange={(e)=>changeIdValue(e)}
            value={idValue}
            style={{
              display:'inline-flex',
              alignItems:'center',
              justifyContent:'center',
              position:'relative',
              boxSizing:'border-box',
              outline:0,
              margin:0,
              userSelect:'none',
              verticalAlign:'middle',
              textDecoration:'none',
              borderRadius:'8px',
              transition: 'background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
              boxShadow: 'none',
              textTransform: 'none',
              fontSize: '16px',
              padding: '18px 22px',
              border: '2px solid',
              lineHeight: '1.5',
              backgroundColor: '#fff',
              color: '#637381',
              borderColor: 'rgba(145, 158, 171, 0.24)',
              fontFamily: 'Poppins',
              fontWeight: '500',
              maxWidth: '150px',
              maxHeight:'52px'
            }}/>
            </Grid>
            <Grid item xs={12} lg={2.5}>
              <Filter
                buttonName={"type"}
                donorFilterObj={donorFilterObj}
                donorFilter={donorFilter}
                setDonorFilterValue={setDonorFilterValue}
                t={t}
              />
            </Grid>
            <Grid item xs={12} lg={5}>
              <OrderDonation
                buttonName={"period"}
                orderByObj={orderByObj}
                orderChecked={orderCheck}
                setOrderChecked={setOrderCheckValue}
                t={t}
              />
            </Grid>
          </Grid>
        </Grid> */}
        {loading && <Loader phrase={"collectionDoanationLoadingPhrase"} t={t} />}
      {!loading &&
        myActiveDonations?.length > 0 &&
        <DonationCard  all= {myActiveDonations} messagens = {mensagensEntidades} t={t} donationStatus={donationStatus} donationFilter={donorFilter} />
        // myActiveDonations?.map((listItem, index) => (
        //   <DonationCard all= {myActiveDonations} item={listItem} t={t} key={listItem?.donation.id} donationStatus={donationStatus} donationFilter={donorFilter} />
        // ))
        }
        
      {/* {!loading && myActiveDonations.length > 0 && (
        <Stack spacing={2} alignItems={"center"}>
          <Pagination
            count={totalPageCount}
            variant="outlined"
            color="primary"
            onChange={handleChange}
            page={myActiveDonationsPage}
          />
        </Stack>
      )} */}
      {myActiveDonations.length === 0 && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            mt: "5%",
          }}
        >
          <Avatar sx={avataStyles}>
            <SvgIconStyle src="/static/dashboard/box.svg" sx={svgIconStyle} />
          </Avatar>
          <Box sx={{ paddingLeft: "10px" }}>
            <Typography sx={{ marginTop: "10px" }}>
              {entity?.isParentEntity ? t("parentEntityNoDonation"):t("childEntityNoDonation") }
            </Typography>
          </Box>
        </Box>
      )}
    </Stack>
  );
};

export default Donations;
